import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import Contact from "./pages/Contact";
import Leadership from "./pages/Leadership";
import Brands from "./pages/Brands";

function App() {
  return (
    <div className="App min-h-screen bg-cream">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/products" element={<Products />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/leadership" element={<Leadership />} />
          <Route path="/brands" element={<Brands />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
